module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_RHD.b5c149a0.jpg";